import React from 'react';
import {Link, useParams} from 'react-router-dom';

import LanguageSwitcher from '../../i18n/LanguageSwitcher';
import {FormattedMessage} from 'react-intl';
import {Button, Col, Row} from 'react-bootstrap';
import PropTypes from 'prop-types';
import {isAuthenticated, logout} from '../../auth';

const Header = ({enabledLanguages}) => {

    const {slug} = useParams();

    return <>
        <Row className="header">
            <Col sm={{span: 3, offset: 8}}>
                <img className="dachmarken-logo" alt="Dachmarkenlogo" src="Leipziger_Messe_DM_rgb.png"/>
                <div className="dachmarken-logo"></div>
            </Col>
        </Row>
        <Row>
            <Col sm={{span: 2, offset: 8}} className="text-right">
                {isAuthenticated()
                    ? (
                        <Button variant="link" onClick={logout}>
                            <i className="fa fa-sign-out"/>&nbsp;
                            <FormattedMessage id="header.link.logout"/>
                        </Button>
                    )
                    : null
                }
            </Col>
        </Row>
        <Row className="header-bar">
            <Col>
                <Link to={`/${slug}/legal`} target="_blank" rel="noopener noreferrer">
                    <FormattedMessage id="header.link.legal"/>
                </Link>
            </Col>
            <Col className="text-right">
                <Link to={`/${slug}/contact`} target="_blank" rel="noopener noreferrer">
                    <FormattedMessage id="header.link.contact"/>
                </Link>
                &nbsp;&nbsp;
                <LanguageSwitcher enabledLanguages={enabledLanguages}/>
            </Col>
        </Row>
    </>;
};

Header.propTypes = {
    enabledLanguages: PropTypes.object
};

export default Header;
